/* eslint-disable react/jsx-key */
import { BoxWrapper } from 'components/Base';
import React, { useState } from 'react';
import CheckIcon from '@material-ui/icons/Check';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import LinkCard from 'components/Homepage/components/LinkCard';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import MarketCommentaries from './../Sidebar/MarketCommentaries';
import DropdownInput from 'components/Dropdown/Dropdown';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import { Grid } from '@material-ui/core';
import BlankUser from 'assets/images/blankUser.png';
import { ReactComponent as DocumentIcon } from 'assets/icons/document.svg';

import moment from 'moment';
import ContactModal from './ContactModal';
import { Notify } from 'utils';
import { sortPlatforms } from '../utils';

interface Props {
  provider: any;
  legalRelationships: any;
}

const Sidebar = ({ provider, legalRelationships }: Props) => {
  const [factsheetRange, setFactsheetRange] = useState() as any;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const formatTime = (time: string) => {
    return moment(time, 'HH:mm:ss').format('HH:mm');
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} lg={12} style={{ display: 'flex' }}>
          <BoxWrapper title="Enquires" style={{ flex: 1 }}>
            <div style={{ padding: '1rem' }}>
              <Grid container>
                {provider.contact_number && (
                  <Grid item xs={6}>
                    <LinkCard
                      icon={<PhoneIcon />}
                      onClick={(e: any) => {
                        window.location.href = `tel:${provider.contact_number}`;
                        e.preventDefault();
                      }}
                    >
                      <div>{provider.contact_number}</div>
                    </LinkCard>
                  </Grid>
                )}
                {provider.computed_email && (
                  <Grid item xs={6}>
                    <LinkCard
                      icon={<EmailIcon />}
                      onClick={() => {
                        setIsModalOpen(true);
                      }}
                    >
                      <div>Send enquiry</div>
                    </LinkCard>
                  </Grid>
                )}
              </Grid>
            </div>
          </BoxWrapper>
        </Grid>
        {provider.key_contacts.length > 0 && (
          <Grid item xs={12} md={6} lg={12} style={{ display: 'flex' }}>
            <BoxWrapper title="Key Contacts" style={{ flex: 1 }}>
              <div style={{ padding: '1rem' }}>
                <Grid
                  container
                  direction="column"
                  style={{
                    gap: '1rem'
                  }}
                >
                  {provider.key_contacts.map((contact: any) => {
                    return (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img
                          src={
                            contact.profile_picture_url
                              ? contact.profile_picture_url
                              : BlankUser
                          }
                          style={{
                            borderRadius: '50%',
                            border: '3px solid rgb(0, 128, 189)',
                            width: '100px',
                            height: '100px',
                            objectFit: 'cover'
                          }}
                        />
                        <div style={{ marginLeft: '1rem' }}>
                          {contact.name && (
                            <div
                              style={{
                                fontSize: '1.2rem',
                                fontWeight: 700,
                                color: '#0280bd'
                              }}
                            >
                              {contact.name}
                            </div>
                          )}
                          {contact.job_title && <div>{contact.job_title}</div>}
                        </div>

                        <div
                          style={{
                            marginLeft: 'auto',
                            display: 'flex',
                            gap: '1rem'
                          }}
                        >
                          {contact.contact_number && (
                            <a href={`tel:${contact.contact_number}`}>
                              <PhoneIcon
                                style={{ cursor: 'pointer', color: '#000' }}
                              />
                            </a>
                          )}

                          {contact.email && (
                            <a href={`mailto:${contact.email}`}>
                              <EmailIcon
                                style={{ cursor: 'pointer', color: '#000' }}
                              />
                            </a>
                          )}

                          {contact.linkedin_url && (
                            <a
                              href={contact.linkedin_url}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <LinkedInIcon
                                style={{ cursor: 'pointer', color: '#000' }}
                              />
                            </a>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </Grid>
              </div>
            </BoxWrapper>
          </Grid>
        )}

        {provider.resources.length > 0 && (
          <Grid item xs={12} md={6} lg={12} style={{ display: 'flex' }}>
            <BoxWrapper title="Resources" style={{ flex: 1 }}>
              <div style={{ padding: '1rem' }}>
                <Grid
                  container
                  direction="column"
                  style={{
                    gap: '1rem'
                  }}
                >
                  {provider.resources.map((resource: any, index: number) => {
                    return (
                      <LinkCard
                        key={index}
                        icon={
                          <DocumentIcon
                            color="#136082"
                            style={{ height: '24px' }}
                          />
                        }
                        onClick={() => {
                          const link = document.createElement('a');
                          link.href = resource.document_url;
                          link.target = '_blank';
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }}
                      >
                        {resource.name}
                      </LinkCard>
                    );
                  })}
                </Grid>
              </div>
            </BoxWrapper>
          </Grid>
        )}

        {provider.portfolio_ranges.length > 0 && provider.claimed && (
          <Grid item xs={12} md={6} lg={12} style={{ display: 'flex' }}>
            <BoxWrapper title="Portfolio Factsheets" style={{ flex: 1 }}>
              <div style={{ padding: '1rem' }}>
                <DropdownInput
                  options={provider.portfolio_ranges}
                  label={'Select Portfolio Range'}
                  onChange={(e: any) => {
                    setFactsheetRange(e.id);
                  }}
                  objectKey={'name'}
                  search={true}
                  value={provider.portfolio_ranges[0].name}
                />
                <Grid
                  container
                  direction="column"
                  style={{
                    gap: '1rem',
                    marginTop: '2rem'
                  }}
                >
                  {provider.portfolio_ranges[
                    factsheetRange
                      ? provider.portfolio_ranges.findIndex(
                          (range: any) => range.id == factsheetRange
                        )
                      : 0
                  ].portfolios.map((range: any) => {
                    return (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          borderBottom: '1px dotted #9c9c9c',
                          cursor: 'pointer'
                        }}
                        onClick={() => {
                          if (!range.factsheet_url) {
                            Notify.error(
                              `A portfolio factsheet has not been provided by the MPS provider.`
                            );
                            return;
                          }
                          const link = document.createElement('a');
                          link.href = range.factsheet_url;
                          link.target = '_blank';
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }}
                      >
                        {range.name}
                        {range.factsheet_url && (
                          <DescriptionOutlinedIcon
                            style={{ cursor: 'pointer', color: '#000' }}
                          />
                        )}
                      </div>
                    );
                  })}
                </Grid>
              </div>
            </BoxWrapper>
          </Grid>
        )}
        {provider.market_commentaries.length > 0 && (
          <Grid item xs={12} md={6} lg={12} style={{ display: 'flex' }}>
            <MarketCommentaries provider={provider} />
          </Grid>
        )}
        {provider.platforms.length > 0 && (
          <Grid item xs={12} md={6} lg={12} style={{ display: 'flex' }}>
            <BoxWrapper title="Platform Availability" style={{ flex: 1 }}>
              <div style={{ padding: '1rem' }}>
                <Grid
                  container
                  direction="column"
                  style={{
                    gap: '1rem'
                  }}
                >
                  {sortPlatforms(provider.platforms).map((platform: any) => {
                    return (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          borderBottom: '1px dotted #9c9c9c'
                        }}
                      >
                        {platform.name}
                        <CheckIcon
                          style={{ cursor: 'pointer', color: '#34b233' }}
                        />
                      </div>
                    );
                  })}
                </Grid>
              </div>
            </BoxWrapper>
          </Grid>
        )}
        {provider.legal_relationships?.length > 0 && (
          <Grid item xs={12} md={6} lg={12} style={{ display: 'flex' }}>
            <BoxWrapper title="Legal relationship" style={{ flex: 1 }}>
              <div style={{ padding: '1rem' }}>
                <Grid
                  container
                  direction="column"
                  style={{
                    gap: '1rem'
                  }}
                >
                  {provider.legal_relationships.map(
                    (legalRelationship: any) => {
                      const matchingLegalRelationship = legalRelationships.find(
                        (baseLegalRelationship: any) =>
                          Number(baseLegalRelationship.value) ===
                          Number(legalRelationship)
                      );
                      return (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            borderBottom: '1px dotted #9c9c9c'
                          }}
                        >
                          {matchingLegalRelationship?.name}
                          <CheckIcon
                            style={{ cursor: 'pointer', color: '#34b233' }}
                          />
                        </div>
                      );
                    }
                  )}
                </Grid>
              </div>
            </BoxWrapper>
          </Grid>
        )}
        {provider.events.length > 0 && (
          <Grid
            item
            xs={12}
            md={6}
            lg={12}
            style={{ display: 'flex', gap: '2rem' }}
          >
            <BoxWrapper title="Events" style={{ flex: 1 }}>
              <div style={{ padding: '1rem' }}>
                <Grid
                  container
                  direction="column"
                  spacing={1}
                  style={{ gap: '1rem' }}
                >
                  {provider.events
                    .sort((a: any, b: any) => {
                      // Create Date objects for comparison
                      const dateA = new Date(
                        `${a.date}T${a.start_time}`
                      ) as any;
                      const dateB = new Date(
                        `${b.date}T${b.start_time}`
                      ) as any;

                      return dateA - dateB;
                    })
                    .map((event: any) => {
                      const formattedDate = moment(event.date)
                        .format('MMM D YYYY')
                        .split(' ');
                      return (
                        <Grid
                          container
                          spacing={2}
                          style={{ alignItems: 'center' }}
                        >
                          <Grid item xs={5} style={{ paddingRight: '1.25rem' }}>
                            <img
                              src={event.image_url || provider.logo_url}
                              alt={event.name}
                              style={{ width: '100%', borderRadius: '25px' }}
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <div
                              style={{
                                fontWeight: '700',
                                fontSize: '1.2rem',
                                textAlign: 'center'
                              }}
                            >
                              <div>{formattedDate[1]}</div>
                              <div>{formattedDate[0]}</div>
                              <div>{formattedDate[2]}</div>
                            </div>
                          </Grid>
                          <Grid
                            item
                            xs={5}
                            style={{
                              fontSize: '0.875rem'
                            }}
                          >
                            <div>
                              <div
                                style={{
                                  color: 'rgb(2, 128, 189)',
                                  fontWeight: '700'
                                }}
                              >
                                {event.name}
                              </div>
                              <div>{event.location}</div>
                              <div style={{ fontWeight: '700' }}>
                                {formatTime(event.start_time)} -{' '}
                                {formatTime(event.end_time)}
                              </div>
                              <a
                                href={event.booking_link}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  color: '#0280bd',
                                  textDecoration: 'none'
                                }}
                              >
                                More details
                              </a>
                            </div>
                          </Grid>
                        </Grid>
                      );
                    })}
                </Grid>
              </div>
            </BoxWrapper>
          </Grid>
        )}
      </Grid>

      <ContactModal
        provider={provider}
        isModalOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default Sidebar;
